import { render } from "./TagPill.vue?vue&type=template&id=98d0df90"
import script from "./TagPill.vue?vue&type=script&lang=js"
export * from "./TagPill.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__